// window.onWizzyScriptLoaded = function () {
//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
//         function (products) {
//             products.forEach(function (product) {
//                 var attributes = product.attributes;
//                 if (attributes) {
//                     attributes.forEach(function (attr) {
//                         if (attr.id === 'product_handle') {
//                             product.handle = attr.values[0].value[0];
//                         }
//                     });
//                 }
//             });
//             setTimeout(applyWizzyLowStockBadges, 150);
//             return products;
//         }
//     );  

//     window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
//         function (data) {
//             data.search.configs.facets.showPriceInputRangeFields = true;
//             data.filters.configs.layout = 'v1';
//             data.search.configs.facets.leftFacets.mobileCollapsible = !0;
//             window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = !0;
//             data.search.configs.facets.leftFacets.defaultCollapsed = !0;
//             return data;
//         }
//     );
//         window.wizzyConfig.events.registerEvent(
//         window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
//         function (data) {
//             data.search.configs.facets.showPriceInputRangeFields = true;
//             data.filters.configs.layout = 'v1';
//             window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = !0;
//             data.search.configs.facets.leftFacets.mobileCollapsible = !0;
//             data.search.configs.facets.leftFacets.defaultCollapsed = !0;
//             return data;
//         }
//     );

//     var lowStockTimer;
//     new MutationObserver(function () {
//         clearTimeout(lowStockTimer);
//         lowStockTimer = setTimeout(applyWizzyLowStockBadges, 150);
//     }).observe(document.body, { childList: true, subtree: true });
// };

// var WIZZY_LOW_STOCK_THRESHOLD = 5;
// var wizzyStockCache = {};
// var wizzyStockPending = {};

// function getAvailableStockForVariants(url) {
//     try {
//         var cleanUrl = new URL(url, window.location.origin);
//         cleanUrl.search = '';
//         cleanUrl.searchParams.set('view', 'qty');
//         var qtyUrl = cleanUrl.toString();

//         if (wizzyStockCache[qtyUrl]) {
//             return Promise.resolve(wizzyStockCache[qtyUrl]);
//         }
//         if (wizzyStockPending[qtyUrl]) {
//             return wizzyStockPending[qtyUrl];
//         }

//         wizzyStockPending[qtyUrl] = fetch(qtyUrl)
//             .then(function (response) {
//                 if (!response.ok) {
//                     throw new Error('HTTP error! Status: ' + response.status);
//                 }
//                 return response.text();
//             })
//             .then(function (rawText) {
//                 var jsonData = JSON.parse(rawText);
//                 wizzyStockCache[qtyUrl] = jsonData;
//                 return jsonData;
//             })
//             .catch(function (error) {
//                 console.error('Failed to fetch custom template JSON:', error);
//                 return {};
//             })
//             .finally(function () {
//                 delete wizzyStockPending[qtyUrl];
//             });

//         return wizzyStockPending[qtyUrl];
//     } catch (e) {
//         console.error('Invalid URL provided to the function:', e);
//         return Promise.resolve({});
//     }
// }

// function applyWizzyLowStockBadges() {
//     var cards = document.querySelectorAll(
//         '.wizzy-search-results-list .plp-card, .wizzy-autocomplete-wrapper .plp-card'
//     );

//     cards.forEach(function (card) {
//         if (card.getAttribute('data-wizzy-low-stock-checked')) {
//             return;
//         }

//         var link = card.querySelector('.plp-card__media-link');
//         var variantInput = card.querySelector('input[name="id"]');
//         if (!link || !variantInput) {
//             return;
//         }

//         card.setAttribute('data-wizzy-low-stock-checked', 'true');

//         getAvailableStockForVariants(link.href).then(function (stockMap) {
//             var qty = stockMap[variantInput.value];
//             if (!(qty > 0 && qty <= WIZZY_LOW_STOCK_THRESHOLD)) {
//                 return;
//             }

//             var media = card.querySelector('.plp-card__media');
//             if (!media || media.querySelector('[data-wizzy-low-stock]')) {
//                 return;
//             }

//             var badge = document.createElement('span');
//             badge.className = 'plp-card__badge plp-card__badge--low';
//             badge.setAttribute('data-wizzy-low-stock', 'true');
//             badge.textContent = 'LOW STOCK';
//             media.insertBefore(badge, media.firstChild);
//         });
//     });
// }
//     const targetNode = document.querySelector(".wizzy-body-end-wrapper");
//     function updateBodyClass() {
//         const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
//         autocompleteElement && window.getComputedStyle(autocompleteElement).display === "flex" ? document.body.classList.add("wizzy-autocomplete-open") : document.body.classList.remove("wizzy-autocomplete-open")
//     }
//     const config = {
//         childList: !0,
//         subtree: !0,
//         attributes: !0,
//         attributeFilter: ["style"]
//     }
//       , callback = function(mutationsList, observer2) {
//         for (const mutation of mutationsList) {
//             updateBodyClass();
//             break
//         }
//     }
//       , observer = new MutationObserver(callback);
//     targetNode && (observer.observe(targetNode, config),
//     updateBodyClass())

// document.body.addEventListener("click", function (event) {
//     if (event.target.matches(".aone-header__search-input")) {
//         setTimeout(syncAutocompleteWidth, 100);
//     }
// });

// document.body.addEventListener("input", function (event) {
//     if (event.target.matches(".aone-header__search-input")) {
//         setTimeout(syncAutocompleteWidth, 100);
//     }
// });

function syncAutocompleteWidth() {
    const wrapper = document.querySelector('.wizzy-autocomplete-wrapper');
    if (!wrapper) return;

    var viewportPadLeft = 12;
    var viewportPadRight = 12;
    var available = Math.max(0, window.innerWidth - viewportPadLeft - viewportPadRight);
    var isMobile = window.innerWidth <= 768;

    var top = wrapper.getBoundingClientRect().top;
    var spaceBelow = Math.max(220, window.innerHeight - top - 16);
    // Desktop: allow more height (~72vh); mobile: use remaining space
    var maxH = isMobile ? spaceBelow : Math.min(spaceBelow, Math.floor(window.innerHeight * 0.72));
    wrapper.style.maxHeight = maxH + 'px';
    wrapper.style.overflowY = 'auto';
    wrapper.style.overflowX = 'auto';
    wrapper.style.webkitOverflowScrolling = 'touch';
    wrapper.style.boxSizing = 'border-box';

    if (isMobile) {
        wrapper.style.left = viewportPadLeft + 'px';
        wrapper.style.right = viewportPadRight + 'px';
        wrapper.style.width = available + 'px';
        wrapper.style.minWidth = '0';
        wrapper.style.maxWidth = available + 'px';
        wrapper.style.overflowX = 'hidden';
        return;
    }

    // Desktop: size to content, cap at viewport; scroll if content > vw
    wrapper.style.right = 'auto';
    wrapper.style.width = 'max-content';
    wrapper.style.minWidth = Math.min(920, available) + 'px';
    wrapper.style.maxWidth = available + 'px';

    var left = parseFloat(wrapper.style.left);
    if (isNaN(left)) {
        left = wrapper.getBoundingClientRect().left;
    }

    // Measure natural content width after max-content applies
    var contentW = Math.ceil(wrapper.scrollWidth);
    var panelW = Math.min(Math.max(contentW, Math.min(920, available)), available);

    if (left + panelW > window.innerWidth - viewportPadRight) {
        left = Math.max(viewportPadLeft, window.innerWidth - viewportPadRight - panelW);
    }
    if (left < viewportPadLeft) left = viewportPadLeft;
    wrapper.style.left = left + 'px';
}

/**
 * Force Wizzy numbered pagination (not infinite scroll) and disable move-to-top widget.
 * @param {object} data
 * @returns {object}
 */
function applyWizzyNumberedPaginationConfig(data) {
    if (!data.search) {
        data.search = {};
    }

    if (!data.search.configs) {
        data.search.configs = {};
    }

    if (!data.search.configs.pagination) {
        data.search.configs.pagination = {};
    }

    data.search.configs.pagination.type = 'numbered';

    if (!data.search.configs.pagination.moveToTopWidget) {
        data.search.configs.pagination.moveToTopWidget = {};
    }

    data.search.configs.pagination.moveToTopWidget.add = false;

    return data;
}

/**
 * Reformat Wizzy's rendered page list to:
 * first, one before active, active, two after, last - with ellipses for gaps.
 * Does not call the Wizzy search API; only adjusts DOM Wizzy already rendered.
 */
function fixWizzyPaginationExpectedBehavior() {
    const pagesBefore = 1;
    const pagesAfter = 2;

    const pagination = document.querySelector(
        '.wizzy-search-pagination .wizzy-pagination-list'
    );

    if (!pagination) {
        return;
    }

    const activePageElement = pagination.querySelector('li.active[data-page]');

    const pageElements = Array.from(
        pagination.querySelectorAll('li[data-page]')
    );

    if (!activePageElement || pageElements.length === 0) {
        return;
    }

    const activePage = Number.parseInt(activePageElement.dataset.page, 10);

    const availablePageNumbers = pageElements
        .map(function (element) {
            return Number.parseInt(element.dataset.page, 10);
        })
        .filter(function (page) {
            return Number.isFinite(page) && page > 0;
        });

    if (!Number.isFinite(activePage) || availablePageNumbers.length === 0) {
        return;
    }

    const lastPage = Math.max.apply(null, availablePageNumbers);

    if (!Number.isFinite(lastPage) || lastPage <= 0) {
        return;
    }

    const pagesToDisplay = new Set([1, lastPage]);

    for (
        let page = activePage - pagesBefore;
        page <= activePage + pagesAfter;
        page += 1
    ) {
        if (page >= 1 && page <= lastPage) {
            pagesToDisplay.add(page);
        }
    }

    const sortedPages = Array.from(pagesToDisplay).sort(function (a, b) {
        return a - b;
    });

    const nextArrow = pagination.querySelector('.next-arrow');

    /*
     * Keep the original previous and next arrow elements.
     * Remove only the numbered pages and previously generated ellipses.
     */
    pagination
        .querySelectorAll('li:not(.pagination-arrow)')
        .forEach(function (element) {
            element.remove();
        });

    sortedPages.forEach(function (page, index) {
        const previousPage = sortedPages[index - 1];

        if (
            index > 0 &&
            Number.isFinite(previousPage) &&
            page - previousPage > 1
        ) {
            const dots = document.createElement('li');

            dots.className = 'wizzy-pagination-ellipsis';
            dots.setAttribute('aria-hidden', 'true');
            dots.innerHTML =
                '<span class="text wizzy-pagination-ellipsis__text">...</span>';

            pagination.insertBefore(dots, nextArrow || null);
        }

        const listItem = document.createElement('li');

        listItem.setAttribute('title', String(page));
        listItem.setAttribute('data-page', String(page));

        if (page === activePage) {
            listItem.classList.add('active');
            listItem.setAttribute('aria-current', 'page');
        }

        listItem.innerHTML =
            '<a href="#" aria-label="Page ' +
            page +
            '"><span class="text">' +
            page +
            '</span></a>';

        pagination.insertBefore(listItem, nextArrow || null);
    });
}

/** Remove only the `page` query param; preserve search, filters, sort, and other params. */
function wizzyRemovePageFromUrl() {
    const currentUrl = new URL(window.location.href);

    if (!currentUrl.searchParams.has('page')) {
        return;
    }

    currentUrl.searchParams.delete('page');

    const cleanUrl =
        currentUrl.pathname +
        (currentUrl.searchParams.toString()
            ? '?' + currentUrl.searchParams.toString()
            : '') +
        currentUrl.hash;

    window.history.replaceState(window.history.state, '', cleanUrl);
}

window.onWizzyScriptLoaded = function () {

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER,
        function (data) {
            setTimeout(syncAutocompleteWidth, 2);
            setTimeout(syncAutocompleteWidth, 50);
            scheduleHydrateWizzyCardMeta(80);
            scheduleHydrateWizzyCardMeta(250);
            return data;
        }
    );
    window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_AUTOCOMPLETE_RENDER,
    function (data) {
        setTimeout(function () {
            document
                .querySelectorAll(".wz-autocomplete-suggestions-products-wrapper")
                .forEach(function (wrapper) {
                    wrapper.style.display = "none";
                });
        }, 10);

        return data;
    }
);
    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
        function (products) {
            products.forEach(function (product) {
                var attributes = product.attributes;
                if (attributes) {
                    attributes.forEach(function (attr) {
                        if (!product.handle && (attr.id === 'product_handle' || attr.id === 'handle')) {
                            var handleValue = readWizzyAttributeValue(attr);
                            if (handleValue) product.handle = handleValue;
                        }
                        if (!product.sku && isWizzySkuAttribute(attr)) {
                            var skuValue = readWizzyAttributeValue(attr);
                            if (skuValue) product.sku = skuValue;
                        }
                    });
                }
                if (!product.sku && product.SKU) {
                    product.sku = product.SKU;
                }
                if (!product.sku && product.variants && product.variants.length && product.variants[0].sku) {
                    product.sku = product.variants[0].sku;
                }
                // Ensure handle exists for Quick View / weight fetch on search + collection.
                // Search payloads sometimes omit `handle` while still providing a product URL.
                if (!product.handle) {
                    var urlCandidate =
                        product.url ||
                        product.groupUrl ||
                        product.productUrl ||
                        product.link ||
                        product.slug ||
                        '';
                    try {
                        var path = String(urlCandidate);
                        var m = path.match(/\/products\/([^/?#]+)/);
                        if (m && m[1]) {
                            product.handle = decodeURIComponent(m[1]);
                        } else if (path && path.indexOf('/') === -1 && path.indexOf(' ') === -1) {
                            // Some Wizzy payloads put a bare handle in `slug`
                            product.handle = path;
                        }
                    } catch (e) {
                        /* noop */
                    }
                }
            });
            setTimeout(applyWizzyLowStockBadges, 150);
            setTimeout(syncWizzyProductHandlesInDom, 0);
            setTimeout(initWizzySearchViewSwitcher, 0);
            // One products-batch hydrate for min weight + available qty.
            scheduleHydrateWizzyCardMeta(200);
            return products;
        }
    );  

    window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
        function (data) {
//             data.credentials{
//     "apiKey": "OVBkVXQyclVqVlVDTFIwNTFibG52TFkreGQ2U1RzWkEvNDhVekJZRkNabzBsdkdHVlhyRUJteGh1eUtaMXR6S25lMnd0Y1VXRXZEbUV6OWd3MXpSYnZNQVVpaklIWWVyd0ViTU9scjgwNlU9",
//     "storeId": "d682dbd647a511f181f50a0c8095feae"
// };


            // const header = document.querySelector('.aone-header__main-inner');

// function toggleHeader() {
//   const filterOpen = document.body.classList.contains('wizzy-filters-overlay');

//   if (header) {
//     header.style.display = filterOpen ? 'none' : '';
//   }
// }

// new MutationObserver(toggleHeader).observe(document.body, {
//   attributes: true,
//   attributeFilter: ['class']
// });

// toggleHeader();

            data.search.configs.facets.showPriceInputRangeFields = true;
            data.filters.configs.layout = 'v1';
            data.search.configs.facets.leftFacets.mobileCollapsible = !0;
            window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = !0;
            data.search.configs.facets.leftFacets.defaultCollapsed = !0;

            applyWizzyNumberedPaginationConfig(data);

            return data;
        }
    );
        window.wizzyConfig.events.registerEvent(
        window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
        function (data) {
//             data.credentials{
//     "apiKey": "OVBkVXQyclVqVlVDTFIwNTFibG52TFkreGQ2U1RzWkEvNDhVekJZRkNabzBsdkdHVlhyRUJteGh1eUtaMXR6S25lMnd0Y1VXRXZEbUV6OWd3MXpSYnZNQVVpaklIWWVyd0ViTU9scjgwNlU9",
//     "storeId": "d682dbd647a511f181f50a0c8095feae"
// };
            data.search.configs.facets.showPriceInputRangeFields = true;
            data.filters.configs.layout = 'v1';
            window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = !0;
            data.search.configs.facets.leftFacets.mobileCollapsible = !0;
            data.search.configs.facets.leftFacets.defaultCollapsed = !0;

            applyWizzyNumberedPaginationConfig(data);

            return data;
        }
    );

    if (!window.__customWizzyPaginationInitialized) {
        window.__customWizzyPaginationInitialized = true;

        window.wizzyConfig.events.registerEvent(
            window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
            function (data) {
                try {
                    wizzyRemovePageFromUrl();

                    fixWizzyPaginationExpectedBehavior();

                    window.requestAnimationFrame(function () {
                        fixWizzyPaginationExpectedBehavior();
                    });

                    window.setTimeout(fixWizzyPaginationExpectedBehavior, 300);

                    window.setTimeout(fixWizzyPaginationExpectedBehavior, 1000);
                } catch (paginationError) {
                    console.error(
                        'Unable to format Wizzy pagination:',
                        paginationError
                    );
                }

                return data;
            }
        );
    }

    var lowStockTimer;
    new MutationObserver(function (mutations) {
        var hasNewWizzyCards = false;
        for (var i = 0; i < mutations.length; i++) {
            var added = mutations[i].addedNodes;
            if (!added || !added.length) continue;
            for (var j = 0; j < added.length; j++) {
                var node = added[j];
                if (!(node instanceof Element)) continue;
                if (
                    node.matches &&
                    (node.matches(
                        '.wizzy-search-results-list .plp-card, .wizzy-search-results-list .inventory-product-row, .wizzy-result-product, .plp-card'
                    ) ||
                        (node.querySelector &&
                            node.querySelector(
                                '.wizzy-search-results-list .plp-card, .wizzy-search-results-list .inventory-product-row, .wizzy-result-product .plp-card'
                            )))
                ) {
                    hasNewWizzyCards = true;
                    break;
                }
            }
            if (hasNewWizzyCards) break;
        }
        clearTimeout(lowStockTimer);
        lowStockTimer = setTimeout(function () {
            applyWizzyLowStockBadges();
            if (hasNewWizzyCards) {
                scheduleHydrateWizzyCardMeta(150);
            }
        }, 200);
    }).observe(document.body, { childList: true, subtree: true });
};

var WIZZY_LOW_STOCK_THRESHOLD = 5;
var wizzyStockCache = {};
var wizzyStockPending = {};
/** @type {Record<string, number|null>} sku(lower) -> grams (null = known missing) */
var wizzyWeightCache = {};
var wizzyWeightHydrateTimer = null;
var wizzyWeightRestoreTimer = null;
var wizzyWeightInFlightKey = '';
/** @type {Promise<Record<string, number>>|null} */
var wizzyWeightInFlightPromise = null;
var wizzyWeightRestoreObserver = null;
/**
 * productId -> { weight: number|null, qty: number|null }
 * Source of truth for Wizzy card meta (products-batch).
 * @type {Record<string, { weight: number|null, qty: number|null }>}
 */
var wizzyMetaCache = {};
var wizzyMetaHydrateTimer = null;
/** Grid cards + order-sheet rows inside Wizzy results (collection + search + autocomplete). */
var WIZZY_META_CARD_SELECTOR =
    '.wizzy-search-results-list .plp-card[data-product-id], .wizzy-search-results-list .inventory-product-row[data-product-id], .wizzy-autocomplete-wrapper .plp-card[data-product-id]';
var WIZZY_META_EMPTY_DISPLAY = 'N/A';
var WIZZY_META_LOADING_DISPLAY = 'Checking...';
var WIZZY_BUTTON_LOADING_DISPLAY = 'Checking availability...';
var WIZZY_BUTTON_ADD_TO_CART = 'ADD TO CART';
var WIZZY_BUTTON_COMING_SOON = 'COMING SOON';
var WIZZY_WMS_REQUEST_TIMEOUT_MS = 20000;
var wizzyMetaRestoreTimer = null;
var wizzyMetaInFlightKey = '';
/** @type {Promise<Record<string, { weight: number|null, qty: number|null }>>|null} */
var wizzyMetaInFlightPromise = null;
var wizzyMetaRestoreObserver = null;
var wizzyMetaPageshowBound = false;
/** Lightweight generation token so stale Wizzy batch responses cannot overwrite newer paints. */
var wizzyMetaRequestGeneration = 0;

function isWizzySkuAttribute(attr) {
    if (!attr || !attr.id) return false;
    var id = String(attr.id).toLowerCase();
    return id === 'sku' || id === 'variant_sku' || id === 'product_sku' || id.indexOf('sku') !== -1;
}

function readWizzyAttributeValue(attr) {
    try {
        if (!attr || !attr.values || !attr.values.length) return '';
        var first = attr.values[0];
        if (first == null) return '';
        if (typeof first === 'string' || typeof first === 'number') return String(first).trim();
        if (first.value != null) {
            if (Array.isArray(first.value)) return String(first.value[0] || '').trim();
            return String(first.value).trim();
        }
    } catch (e) {
        /* noop */
    }
    return '';
}

/** Backfill data-product-handle on Wizzy cards from product links when missing. */
function syncWizzyProductHandlesInDom() {
    document
        .querySelectorAll(
            '.wizzy-search-results-list .plp-card, .wizzy-search-results-list .inventory-product-row, .wizzy-autocomplete-wrapper .plp-card'
        )
        .forEach(function (card) {
            if (!(card instanceof HTMLElement)) return;
            if (card.getAttribute('data-product-handle')) return;
            var link = card.querySelector(
                'a.plp-card__media-link, a.inventory-product-row__media-link, a[href*="/products/"]'
            );
            if (!(link instanceof HTMLAnchorElement)) {
                var item = card.closest('.plp-product-grid__item');
                link = item ? item.querySelector('a[href*="/products/"]') : null;
            }
            if (!(link instanceof HTMLAnchorElement)) return;
            var match = String(link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
            if (!match || !match[1]) return;
            card.setAttribute('data-product-handle', decodeURIComponent(match[1]));
        });
}

function getWizzyWeightApiConfig() {
    // Prefer live theme WMS config (same source collection / weight-service uses).
    try {
        var liveCfg = window.AOneWmsConfig;
        if (liveCfg && liveCfg.enabled !== false && liveCfg.apiBaseUrl) {
            return {
                apiBaseUrl: String(liveCfg.apiBaseUrl).replace(/\/+$/, ''),
                weightsPath: '/public/products',
                timeoutMs: Math.max(
                    WIZZY_WMS_REQUEST_TIMEOUT_MS,
                    Number(liveCfg.timeoutMs) || WIZZY_WMS_REQUEST_TIMEOUT_MS
                ),
            };
        }
    } catch (liveErr) {
        /* noop */
    }

    // Same sources collection uses: theme batch config, then PLP section weight config.
    var batchEl = document.querySelector('[data-batch-weight-config]');
    if (batchEl) {
        try {
            var batch = JSON.parse(batchEl.textContent || '{}');
            if (batch && batch.enabled && batch.baseUrl) {
                return {
                    apiBaseUrl: String(batch.baseUrl).replace(/\/+$/, ''),
                    weightsPath: '/public/products',
                    timeoutMs: Math.max(
                        WIZZY_WMS_REQUEST_TIMEOUT_MS,
                        Number(batch.timeoutMs) || WIZZY_WMS_REQUEST_TIMEOUT_MS
                    ),
                };
            }
        } catch (e) {
            /* noop */
        }
    }

    var sectionEl = document.querySelector(
        '[data-plp-fetch-weight-config-section], [data-plp-fetch-weight-config], [data-pdp-fetch-weight-config]'
    );
    if (sectionEl) {
        try {
            var section = JSON.parse(sectionEl.textContent || '{}');
            var base = section && (section.apiBaseUrl || section.baseUrl);
            if (base) {
                return {
                    apiBaseUrl: String(base).replace(/\/+$/, ''),
                    weightsPath: String(section.weightsPath || '/public/products').replace(/\/+$/, '') || '/public/products',
                    timeoutMs: WIZZY_WMS_REQUEST_TIMEOUT_MS,
                };
            }
        } catch (e2) {
            /* noop */
        }
    }

    return null;
}

function isBatchWeightApiEnabled() {
    return !!getWizzyWeightApiConfig();
}

function getAvailableStockForVariants(url) {
    try {
        var cleanUrl = new URL(url, window.location.origin);
        cleanUrl.search = '';
        cleanUrl.searchParams.set('view', 'qty');
        var qtyUrl = cleanUrl.toString();

        if (wizzyStockCache[qtyUrl]) {
            return Promise.resolve(wizzyStockCache[qtyUrl]);
        }
        if (wizzyStockPending[qtyUrl]) {
            return wizzyStockPending[qtyUrl];
        }

        wizzyStockPending[qtyUrl] = fetch(qtyUrl)
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('HTTP error! Status: ' + response.status);
                }
                return response.text();
            })
            .then(function (rawText) {
                var jsonData = JSON.parse(rawText);
                wizzyStockCache[qtyUrl] = jsonData;
                return jsonData;
            })
            .catch(function (error) {
                console.error('Failed to fetch custom template JSON:', error);
                return {};
            })
            .finally(function () {
                delete wizzyStockPending[qtyUrl];
            });

        return wizzyStockPending[qtyUrl];
    } catch (e) {
        console.error('Invalid URL provided to the function:', e);
        return Promise.resolve({});
    }
}

function applyWizzyMinWeightDisplay(card, grams, options) {
    var opts = options || {};
    var minWeightValue = card.querySelector('[data-wizzy-min-weight-value], [data-min-weight-value]');
    if (!minWeightValue) return;

    var n = Number(grams);
    var sku = readWizzyCardSku(card);
    if (Number.isFinite(n) && n > 0) {
        var rounded = Math.round(n * 1000) / 1000;
        minWeightValue.textContent = rounded.toFixed(3) + ' g';
        card.setAttribute('data-min-weight-state', 'ready');
        minWeightValue.removeAttribute('data-min-weight-loading');
        minWeightValue.removeAttribute('data-min-weight-pending');
        minWeightValue.setAttribute('data-state', 'ready');
        if (!opts.interim) {
            card.setAttribute('data-weight-hydrated', 'true');
            card.setAttribute('data-wizzy-weight-ready', 'true');
            if (sku) storeWizzyCachedWeight(sku, rounded);
        }
    } else if (!opts.interim) {
        minWeightValue.textContent = WIZZY_META_EMPTY_DISPLAY;
        card.setAttribute('data-min-weight-state', 'error');
        card.setAttribute('data-weight-hydrated', 'true');
        card.setAttribute('data-wizzy-weight-ready', 'true');
        if (sku) storeWizzyCachedWeight(sku, null);
        minWeightValue.removeAttribute('data-min-weight-loading');
        minWeightValue.removeAttribute('data-min-weight-pending');
        minWeightValue.setAttribute('data-state', 'error');
    }
    var row = card.querySelector('.plp-card__min-weight');
    if (row) {
        row.setAttribute('data-min-weight-state', card.getAttribute('data-min-weight-state') || 'error');
    }
}

function storeWizzyCachedWeight(sku, grams) {
    var key = String(sku || '')
        .trim()
        .toLowerCase();
    if (!key) return;
    var n = Number(grams);
    wizzyWeightCache[key] = Number.isFinite(n) && n > 0 ? n : null;
}

function lookupWizzyCachedWeight(sku) {
    var key = String(sku || '')
        .trim()
        .toLowerCase();
    if (!key || !Object.prototype.hasOwnProperty.call(wizzyWeightCache, key)) return undefined;
    return wizzyWeightCache[key];
}

function scheduleHydrateWizzyCardMinWeights(delayMs) {
    scheduleHydrateWizzyCardMeta(delayMs);
}

function scheduleHydrateWizzyCardAvailableQty(delayMs) {
    scheduleHydrateWizzyCardMeta(delayMs);
}

/**
 * Unified schedule: min weight + available qty from products-batch.
 * @param {number} [delayMs]
 */
function scheduleHydrateWizzyCardMeta(delayMs) {
    ensureWizzyMetaPageshowBinding();
    window.clearTimeout(wizzyMetaHydrateTimer);
    wizzyMetaHydrateTimer = window.setTimeout(function () {
        wizzyMetaHydrateTimer = null;
        hydrateWizzyCardMeta();
    }, delayMs == null ? 200 : delayMs);
}

/** Re-paint when weight-service resets cards to loading after an abort. */
function restoreWizzyWeightsFromCache() {
    restoreWizzyMetaFromCache();
}

function ensureWizzyWeightRestoreObserver() {
    if (wizzyWeightRestoreObserver) return;
    var root =
        document.querySelector('.wizzy-search-results-list') ||
        document.querySelector('.wizzy-search-wrapper') ||
        document.body;
    wizzyWeightRestoreObserver = new MutationObserver(function () {
        window.clearTimeout(wizzyWeightRestoreTimer);
        wizzyWeightRestoreTimer = window.setTimeout(function () {
            wizzyWeightRestoreTimer = null;
            restoreWizzyWeightsFromCache();
        }, 80);
    });
    wizzyWeightRestoreObserver.observe(root, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['data-min-weight-state', 'data-weight-hydrated', 'data-weight-sku'],
    });
}

function setWizzyCardSku(card, sku) {
    var resolved = String(sku || '').trim();
    if (!resolved || !card) return '';
    card.setAttribute('data-weight-sku', resolved);
    var skuEl = card.querySelector('.plp-card__sku');
    if (!skuEl) {
        var body = card.querySelector('.plp-card__body');
        var title = card.querySelector('.plp-card__title');
        if (body) {
            skuEl = document.createElement('p');
            skuEl.className = 'plp-card__sku';
            if (title) body.insertBefore(skuEl, title);
            else body.insertBefore(skuEl, body.firstChild);
        }
    }
    if (skuEl) skuEl.textContent = 'SKU: ' + resolved;
    return resolved;
}

function readWizzyCardSku(card) {
    var fromAttr = String(card.getAttribute('data-weight-sku') || '').trim();
    if (fromAttr) return fromAttr;
    var skuEl = card.querySelector('.plp-card__sku, .inventory-product-row__sku-value');
    if (!skuEl) return '';
    var text = String(skuEl.textContent || '');
    var match = text.match(/SKU:\s*(.+)$/i);
    return String(match ? match[1] : text).trim();
}

/**
 * Same batch endpoint collection uses (weight-service / plp-table-details):
 * POST {base}/public/products/weights/batch  body: { skus: [...] }
 */
function fetchWizzyBatchMinWeights(skus, cfg) {
    var path = String(cfg.weightsPath || '/public/products').replace(/\/+$/, '') + '/weights/batch';
    var base = String(cfg.apiBaseUrl || '').replace(/\/+$/, '');
    var url = base + path;
    var headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    try {
        if (new URL(url, window.location.origin).hostname.toLowerCase().indexOf('ngrok') >= 0) {
            headers['ngrok-skip-browser-warning'] = 'true';
        }
    } catch (e) {
        /* noop */
    }

    var requestKey = skus
        .map(function (s) {
            return String(s).toLowerCase();
        })
        .sort()
        .join('|');

    if (wizzyWeightInFlightPromise && wizzyWeightInFlightKey === requestKey) {
        return wizzyWeightInFlightPromise;
    }

    // Longer than shared 8s timeout - slow APIs were leaving "..." then aborting.
    var timeoutMs = Math.max(12000, Number(cfg.timeoutMs) || 12000);

    function once() {
        var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var timeoutId = window.setTimeout(function () {
            if (controller) controller.abort();
        }, timeoutMs);

        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            headers: headers,
            body: JSON.stringify({ skus: skus }),
            signal: controller ? controller.signal : undefined,
        })
            .then(function (res) {
                if (!res.ok) throw new Error('Weight API HTTP ' + res.status);
                return res.json();
            })
            .then(function (payload) {
                return parseWizzyBatchMinWeightMap(payload, skus);
            })
            .finally(function () {
                window.clearTimeout(timeoutId);
            });
    }

    wizzyWeightInFlightKey = requestKey;
    wizzyWeightInFlightPromise = once()
        .catch(function () {
            // One retry for transient aborts / timeouts
            return once();
        })
        .finally(function () {
            if (wizzyWeightInFlightKey === requestKey) {
                wizzyWeightInFlightKey = '';
                wizzyWeightInFlightPromise = null;
            }
        });

    return wizzyWeightInFlightPromise;
}

function wizzyToFiniteNumber(value) {
    if (typeof value === 'number' && Number.isFinite(value)) return value;
    if (typeof value === 'string') {
        var match = value.replace(/,/g, '').match(/-?\d+(\.\d+)?/);
        if (!match) return null;
        var n = Number(match[0]);
        return Number.isFinite(n) ? n : null;
    }
    return null;
}

function extractWizzyMinFromNode(node) {
    if (node == null) return null;
    var direct = wizzyToFiniteNumber(node);
    if (direct != null && direct > 0) return direct;
    if (Array.isArray(node)) {
        var min = null;
        for (var i = 0; i < node.length; i++) {
            var n = extractWizzyMinFromNode(node[i]);
            if (n == null || n <= 0) continue;
            min = min == null ? n : Math.min(min, n);
        }
        return min;
    }
    if (typeof node !== 'object') return null;
    var preferred = [
        'minWeight',
        'min_weight',
        'minimumWeight',
        'minimum_weight',
        'minWeightGrams',
        'min_weight_grams',
        'weight',
        'weight_g',
        'gross_weight',
        'net_weight',
    ];
    for (var p = 0; p < preferred.length; p++) {
        if (!(preferred[p] in node)) continue;
        var fromPref = extractWizzyMinFromNode(node[preferred[p]]);
        if (fromPref != null && fromPref > 0) return fromPref;
    }
    for (var key in node) {
        if (!Object.prototype.hasOwnProperty.call(node, key)) continue;
        var norm = String(key || '')
            .replace(/[\s_-]+/g, '')
            .toLowerCase();
        if (norm.indexOf('weight') === -1) continue;
        if (norm.indexOf('min') >= 0 || norm === 'weight') {
            var fromKey = wizzyToFiniteNumber(node[key]);
            if (fromKey != null && fromKey > 0) return fromKey;
        }
    }
    var listKeys = ['availableWeights', 'availableOptions', 'weights', 'items', 'results', 'data', 'entries'];
    for (var l = 0; l < listKeys.length; l++) {
        if (!(listKeys[l] in node)) continue;
        var fromList = extractWizzyMinFromNode(node[listKeys[l]]);
        if (fromList != null) return fromList;
    }
    return null;
}

function extractWizzySkuFromObject(obj) {
    if (!obj || typeof obj !== 'object') return '';
    var keys = ['sku', 'SKU', 'productSku', 'product_sku', 'variantSku', 'variant_sku', 'itemCode', 'item_code', 'code'];
    for (var i = 0; i < keys.length; i++) {
        if (!(keys[i] in obj)) continue;
        var sku = String(obj[keys[i]] || '').trim();
        if (sku) return sku;
    }
    return '';
}

function parseWizzyBatchMinWeightMap(payload, requestedSkus) {
    var result = {};
    var requested = {};
    (requestedSkus || []).forEach(function (s) {
        requested[String(s).toLowerCase()] = true;
    });

    function assign(sku, value) {
        var normalized = String(sku || '').trim();
        if (!normalized) return;
        var min = extractWizzyMinFromNode(value);
        if (min != null && min > 0) result[normalized] = min;
    }

    if (Array.isArray(payload)) {
        payload.forEach(function (item) {
            if (!item || typeof item !== 'object') return;
            var sku = extractWizzySkuFromObject(item);
            if (sku) assign(sku, item);
        });
        return result;
    }

    if (!payload || typeof payload !== 'object') return result;

    ['products', 'results', 'items', 'data', 'weights'].forEach(function (listKey) {
        var listOrMap = payload[listKey];
        if (!listOrMap) return;
        if (Array.isArray(listOrMap)) {
            listOrMap.forEach(function (item) {
                if (!item || typeof item !== 'object') return;
                var sku = extractWizzySkuFromObject(item);
                if (sku) assign(sku, item);
            });
        } else if (typeof listOrMap === 'object') {
            Object.keys(listOrMap).forEach(function (key) {
                var normalizedKey = String(key || '').trim();
                if (!normalizedKey) return;
                if (['success', 'status', 'message', 'error', 'errors', 'meta'].indexOf(normalizedKey.toLowerCase()) >= 0) {
                    return;
                }
                if (!Object.keys(requested).length || requested[normalizedKey.toLowerCase()]) {
                    assign(normalizedKey, listOrMap[key]);
                }
            });
            if (Array.isArray(listOrMap.items)) {
                listOrMap.items.forEach(function (item) {
                    if (!item || typeof item !== 'object') return;
                    var sku = extractWizzySkuFromObject(item);
                    if (sku) assign(sku, item);
                });
            }
        }
    });

    // API keyed directly by SKU on the root object
    Object.keys(payload).forEach(function (key) {
        var normalizedKey = String(key || '').trim();
        if (!normalizedKey || !requested[normalizedKey.toLowerCase()]) return;
        assign(normalizedKey, payload[key]);
    });

    return result;
}

/**
 * Wizzy-owned min-weight hydrate - delegated to unified products-batch meta hydrate.
 */
function hydrateWizzyCardMinWeights() {
    hydrateWizzyCardMeta();
}

function fillWizzyWeightsFromBatch(skus, cardsBySku, cfg) {
    var stillLoading = skus.filter(function (sku) {
        return (cardsBySku[sku] || []).some(function (card) {
            return card.getAttribute('data-wizzy-weight-ready') !== 'true';
        });
    });
    if (!stillLoading.length) return;

    fetchWizzyBatchMinWeights(stillLoading, cfg)
        .then(function (map) {
            function lookupGrams(sku) {
                if (map[sku] != null) return map[sku];
                var needle = String(sku).toLowerCase();
                var keys = Object.keys(map);
                for (var i = 0; i < keys.length; i++) {
                    if (keys[i].toLowerCase() === needle) return map[keys[i]];
                }
                return null;
            }

            stillLoading.forEach(function (sku) {
                var grams = lookupGrams(sku);
                if (grams != null) storeWizzyCachedWeight(sku, grams);
                (cardsBySku[sku] || []).forEach(function (card) {
                    if (grams != null) {
                        applyWizzyMinWeightDisplay(card, grams);
                    } else if (card.__wizzyQtyMinWeight != null) {
                        applyWizzyMinWeightDisplay(card, card.__wizzyQtyMinWeight);
                    } else {
                        applyWizzyMinWeightDisplay(card, null);
                    }
                });
            });

            // Re-assert after weight-service may have briefly overwritten DOM
            window.setTimeout(restoreWizzyWeightsFromCache, 100);
            window.setTimeout(restoreWizzyWeightsFromCache, 600);
            window.setTimeout(restoreWizzyWeightsFromCache, 1600);
        })
        .catch(function () {
            stillLoading.forEach(function (sku) {
                (cardsBySku[sku] || []).forEach(function (card) {
                    applyWizzyMinWeightDisplay(card, card.__wizzyQtyMinWeight);
                });
            });
            window.setTimeout(restoreWizzyWeightsFromCache, 100);
        });
}

/**
 * Normalize Shopify product GID / numeric id to digits-only string.
 * @param {unknown} value
 * @returns {string}
 */
function normalizeWizzyProductId(value) {
    if (value == null) return '';
    var stringValue = String(value).trim();
    if (!stringValue) return '';
    if (stringValue.indexOf('/') >= 0) {
        stringValue = stringValue.split('/').pop() || '';
    }
    return String(stringValue).trim();
}

/**
 * @param {string} productId
 * @param {{ weight?: number|null, qty?: number|null }} meta
 */
function storeWizzyCachedMeta(productId, meta) {
    var key = normalizeWizzyProductId(productId);
    if (!key || !meta) return;
    var weightN = Number(meta.weight);
    var qtyN = Number(meta.qty);
    wizzyMetaCache[key] = {
        weight: Number.isFinite(weightN) && weightN > 0 ? weightN : null,
        qty: Number.isFinite(qtyN) && qtyN >= 0 ? Math.floor(qtyN) : null,
    };
    var sku = '';
    try {
        var card = document.querySelector(
            '.wizzy-search-results-list .plp-card[data-product-id="' +
                key +
                '"], .wizzy-search-results-list .inventory-product-row[data-product-id="' +
                key +
                '"]'
        );
        if (card) sku = readWizzyCardSku(card);
    } catch (e) {
        /* noop */
    }
    if (sku) storeWizzyCachedWeight(sku, wizzyMetaCache[key].weight);
}

/**
 * @param {string} productId
 * @returns {{ weight: number|null, qty: number|null }|undefined}
 */
function lookupWizzyCachedMeta(productId) {
    var key = normalizeWizzyProductId(productId);
    if (!key || !Object.prototype.hasOwnProperty.call(wizzyMetaCache, key)) return undefined;
    return wizzyMetaCache[key];
}

/**
 * Read weight + qty from weight-service products-batch store.
 * Uses the same Product Batch fields as collection cards.
 * @param {string} productId
 * @returns {{ weight: number|null, qty: number|null }|undefined}
 */
function lookupWizzyMetaFromAOneStore(productId) {
    var key = normalizeWizzyProductId(productId);
    if (!key) return undefined;
    var store = window.AOneProductWeights;
    if (!store || !store.products || typeof store.products.get !== 'function') return undefined;
    if (!store.products.has(key)) return undefined;

    var product = store.products.get(key);
    if (!product || typeof product !== 'object') {
        return { weight: null, qty: 0 };
    }

    return normalizeWizzyMetaFromProduct(product);
}

/**
 * Normalize a Product Batch product node into Wizzy card meta.
 * Source of truth: summary.totalAvailableQuantity.
 * @param {Record<string, unknown>|null|undefined} product
 * @returns {{ weight: number|null, qty: number }}
 */
function normalizeWizzyMetaFromProduct(product) {
    if (!product || typeof product !== 'object') {
        return { weight: null, qty: 0 };
    }

    var summary =
        product.summary && typeof product.summary === 'object' ? product.summary : {};
    var minWeightOption =
        summary.minimumWeightOption && typeof summary.minimumWeightOption === 'object'
            ? summary.minimumWeightOption
            : null;

    var qtyRaw =
        summary.totalAvailableQuantity != null
            ? summary.totalAvailableQuantity
            : summary.totalAvailableCount != null
              ? summary.totalAvailableCount
              : summary.availableCount != null
                ? summary.availableCount
                : summary.availableQuantity != null
                  ? summary.availableQuantity
                  : product.totalAvailableQuantity != null
                    ? product.totalAvailableQuantity
                    : 0;
    var qtyN = Number(qtyRaw);
    var qty = Number.isFinite(qtyN) && qtyN >= 0 ? Math.floor(qtyN) : 0;

    if (qty <= 0) {
        return { weight: null, qty: 0 };
    }

    var weightRaw =
        summary.overallMinWeight != null
            ? summary.overallMinWeight
            : summary.minWeight != null
              ? summary.minWeight
              : minWeightOption && minWeightOption.weight != null
                ? minWeightOption.weight
                : summary.min_weight != null
                  ? summary.min_weight
                  : product.overallMinWeight != null
                    ? product.overallMinWeight
                    : null;
    var weightN = Number(weightRaw);

    return {
        weight: Number.isFinite(weightN) && weightN > 0 ? weightN : null,
        qty: qty,
    };
}

/**
 * Same final states as collection weight-service:
 * loading | available | coming-soon (never Availability unavailable).
 * @param {{ weight?: number|null, qty?: number|null }|null|undefined} meta
 * @param {{ forceLoading?: boolean }} [options]
 * @returns {{
 *   status: 'loading'|'available'|'coming-soon',
 *   totalAvailableQuantity: number,
 *   minimumWeight: number|null,
 *   buttonText: string,
 *   disabled: boolean
 * }}
 */
function normalizeWizzyWmsAvailability(meta, options) {
    var opts = options || {};
    if (opts.forceLoading) {
        return {
            status: 'loading',
            totalAvailableQuantity: 0,
            minimumWeight: null,
            buttonText: WIZZY_BUTTON_LOADING_DISPLAY,
            disabled: true,
        };
    }

    var qtyN = Number(meta && meta.qty);
    var quantity = Number.isFinite(qtyN) && qtyN > 0 ? Math.floor(qtyN) : 0;
    var weightN = Number(meta && meta.weight);
    var minimumWeight = Number.isFinite(weightN) && weightN > 0 ? weightN : null;

    if (quantity > 0) {
        return {
            status: 'available',
            totalAvailableQuantity: quantity,
            minimumWeight: minimumWeight,
            buttonText: WIZZY_BUTTON_ADD_TO_CART,
            disabled: false,
        };
    }

    return {
        status: 'coming-soon',
        totalAvailableQuantity: 0,
        minimumWeight: null,
        buttonText: WIZZY_BUTTON_COMING_SOON,
        disabled: true,
    };
}

/**
 * @param {HTMLElement} action
 * @param {string} label
 */
function setWizzyActionLabel(action, label) {
    var labelHosts = action.querySelectorAll(
        '.add-to-cart-text__content span span, .quick-add__button-text span span'
    );
    if (labelHosts.length) {
        labelHosts.forEach(function (labelHost) {
            if (labelHost instanceof HTMLElement) labelHost.textContent = label;
        });
        return;
    }
    var fallback = action.querySelector('.add-to-cart-text__content, .quick-add__button-text');
    if (fallback instanceof HTMLElement) {
        var nested = fallback.querySelector('span span') || fallback.querySelector('span');
        if (nested instanceof HTMLElement) nested.textContent = label;
    }
}

/**
 * @param {HTMLElement} action
 * @param {boolean} shouldDisable
 */
function setWizzyActionDisabled(action, shouldDisable) {
    if (!(action instanceof HTMLButtonElement)) return;
    action.disabled = shouldDisable;
    action.setAttribute('aria-disabled', shouldDisable ? 'true' : 'false');
    action.classList.toggle('plp-card__atc--disabled', shouldDisable);
    action.classList.toggle('plp-card__atc--active', !shouldDisable);
}

/**
 * Apply ATC / Coming soon / loading on the current Wizzy card only.
 * @param {HTMLElement} card
 * @param {ReturnType<typeof normalizeWizzyWmsAvailability>} state
 */
function applyWizzyAvailabilityButton(card, state) {
    if (!(card instanceof HTMLElement) || !state) return;

    card.setAttribute('data-wms-status', state.status);
    card.setAttribute(
        'data-wms-inventory-status',
        state.status === 'coming-soon' ? 'coming_soon' : state.status
    );
    card.setAttribute('data-wms-loading', state.status === 'loading' ? 'true' : 'false');
    card.setAttribute('data-wms-available-qty', String(state.totalAvailableQuantity));
    if (state.minimumWeight != null) {
        card.setAttribute('data-wms-min-weight', String(state.minimumWeight));
    } else {
        card.removeAttribute('data-wms-min-weight');
    }

    var availabilityApi = window.WMSInventory || window.AOneWmsAvailability || null;
    var actionNodes = card.querySelectorAll('[data-product-action], .plp-card__atc');
    actionNodes.forEach(function (actionNode) {
        if (!(actionNode instanceof HTMLElement)) return;
        actionNode.setAttribute('aria-busy', state.status === 'loading' ? 'true' : 'false');
        actionNode.setAttribute('data-wms-state', state.status);
        actionNode.setAttribute('data-wms-status', state.status);

        if (availabilityApi && typeof availabilityApi.applyButtonState === 'function') {
            availabilityApi.applyButtonState(actionNode, state.status === 'available' ? 'available' : state.status, {
                label: state.buttonText,
                disabled: state.disabled,
            });
            return;
        }

        setWizzyActionLabel(actionNode, state.buttonText);
        setWizzyActionDisabled(actionNode, state.disabled);
    });

    var shouldShowComingSoon = state.status === 'coming-soon';
    var media = card.querySelector('.plp-card__media');
    if (media instanceof HTMLElement) {
        var badge = media.querySelector('[data-product-sold-out-badge], .plp-card__badge--soldout');
        if (shouldShowComingSoon) {
            if (!badge) {
                badge = document.createElement('span');
                badge.className = 'plp-card__badge plp-card__badge--soldout';
                badge.setAttribute('data-product-sold-out-badge', '');
                media.insertBefore(badge, media.firstChild);
            }
            badge.hidden = false;
            badge.textContent = WIZZY_BUTTON_COMING_SOON;
        } else if (badge) {
            badge.hidden = true;
        }
    }

    var item = card.closest('.plp-product-grid__item, .wizzy-result-product');
    if (item) {
        var listBadgeText =
            item.querySelector('[data-wms-status-badge] .plp-list-card__badge-text') ||
            item.querySelector('[data-wms-status-badge]');
        if (listBadgeText instanceof HTMLElement) {
            if (state.status === 'loading') listBadgeText.textContent = WIZZY_BUTTON_LOADING_DISPLAY;
            else if (state.status === 'coming-soon') listBadgeText.textContent = WIZZY_BUTTON_COMING_SOON;
            else listBadgeText.textContent = 'AVAILABLE';
        }
    }
}

/** Show loaders for weight + qty + ATC while products-batch is in flight. */
function setWizzyCardMetaLoading(card) {
    if (!(card instanceof HTMLElement)) return;

    var minWeightValue = card.querySelector('[data-wizzy-min-weight-value], [data-min-weight-value]');
    if (minWeightValue) {
        minWeightValue.textContent = WIZZY_META_LOADING_DISPLAY;
        minWeightValue.setAttribute('data-min-weight-loading', '');
        minWeightValue.setAttribute('data-state', 'loading');
    }
    card.setAttribute('data-min-weight-state', 'loading');
    card.removeAttribute('data-wizzy-weight-ready');
    card.removeAttribute('data-wizzy-qty-ready');
    card.removeAttribute('data-weight-hydrated');

    var row = card.querySelector('.plp-card__min-weight');
    if (row) row.setAttribute('data-min-weight-state', 'loading');

    var qtyRow = card.querySelector('[data-wizzy-available-qty]');
    var qtyValue = card.querySelector('[data-wizzy-available-qty-value], [data-available-qty-value]');
    if (qtyRow) {
        qtyRow.removeAttribute('hidden');
        qtyRow.setAttribute('data-qty-state', 'loading');
    }
    if (qtyValue) {
        qtyValue.textContent = WIZZY_META_LOADING_DISPLAY;
        qtyValue.setAttribute('data-state', 'loading');
    }

    applyWizzyAvailabilityButton(card, normalizeWizzyWmsAvailability(null, { forceLoading: true }));
}

/**
 * Show Available Qty beside min weight.
 * Zero quantity stays visible as 0 (Coming soon path).
 * @param {HTMLElement} card
 * @param {number|null|undefined} qty
 */
function applyWizzyAvailableQtyDisplay(card, qty) {
    if (!(card instanceof HTMLElement)) return;
    var row = card.querySelector('[data-wizzy-available-qty]');
    var valueEl = card.querySelector('[data-wizzy-available-qty-value], [data-available-qty-value]');
    if (!valueEl) return;

    var n = Number(qty);
    var safeQty = Number.isFinite(n) && n >= 0 ? Math.floor(n) : 0;

    valueEl.textContent = String(safeQty);
    valueEl.setAttribute('data-state', 'ready');
    if (row) {
        row.removeAttribute('hidden');
        row.setAttribute('data-qty-state', 'ready');
    }
    card.setAttribute('data-wizzy-qty-ready', 'true');
}

/**
 * Apply weight + qty + ATC from one normalized WMS state.
 * @param {HTMLElement} card
 * @param {{ weight: number|null, qty: number|null }} meta
 */
function applyWizzyCardMeta(card, meta) {
    if (!(card instanceof HTMLElement) || !meta) return;

    var state = normalizeWizzyWmsAvailability(meta);
    var weightForDisplay = state.status === 'available' ? state.minimumWeight : null;
    var qtyForDisplay = state.totalAvailableQuantity;

    applyWizzyMinWeightDisplay(card, weightForDisplay);
    applyWizzyAvailableQtyDisplay(card, qtyForDisplay);
    applyWizzyAvailabilityButton(card, state);

    if (state.status !== 'loading') {
        card.setAttribute('data-weight-hydrated', 'true');
        card.setAttribute('data-min-weight-state', 'ready');
    }
}

/** Re-paint weight + qty + ATC after weight-service / BFCache DOM resets. */
function restoreWizzyMetaFromCache() {
    var cards = document.querySelectorAll(WIZZY_META_CARD_SELECTOR);
    cards.forEach(function (card) {
        if (!(card instanceof HTMLElement)) return;
        var productId = normalizeWizzyProductId(card.getAttribute('data-product-id'));
        if (!productId) return;

        var cached = lookupWizzyCachedMeta(productId);
        if (cached === undefined) {
            cached = lookupWizzyMetaFromAOneStore(productId);
            if (cached !== undefined) storeWizzyCachedMeta(productId, cached);
        }
        if (cached === undefined) return;

        var state = normalizeWizzyWmsAvailability(cached);
        var stillLoading =
            card.getAttribute('data-min-weight-state') === 'loading' ||
            card.getAttribute('data-wms-status') === 'loading' ||
            !card.getAttribute('data-weight-hydrated');

        var action = card.querySelector('[data-product-action], .plp-card__atc');
        var actionText = action
            ? String(
                  (
                      action.querySelector('.add-to-cart-text__content span span, .quick-add__button-text span span') ||
                      action
                  ).textContent || ''
              ).trim()
            : '';
        var expectedButton = state.buttonText;
        var buttonOk = actionText === expectedButton;

        if (!stillLoading && buttonOk && card.getAttribute('data-wms-status') === state.status) {
            return;
        }
        applyWizzyCardMeta(card, cached);
    });
}

function ensureWizzyMetaRestoreObserver() {
    if (wizzyMetaRestoreObserver) return;
    var root = document.body;
    if (!root) return;

    wizzyMetaRestoreObserver = new MutationObserver(function (mutations) {
        var shouldSync = false;
        for (var i = 0; i < mutations.length; i++) {
            var m = mutations[i];
            if (!m || !m.target || !(m.target instanceof Element)) continue;
            if (
                m.attributeName === 'data-weight-hydrated' ||
                m.attributeName === 'data-min-weight-state' ||
                m.attributeName === 'data-product-id'
            ) {
                if (
                    m.target.matches &&
                    (m.target.matches(
                        '.wizzy-search-results-list .plp-card, .wizzy-search-results-list .inventory-product-row, .wizzy-result-product .plp-card, .wizzy-autocomplete-wrapper .plp-card'
                    ) ||
                        m.target.closest(
                            '.wizzy-search-results-list .plp-card, .wizzy-search-results-list .inventory-product-row, .wizzy-autocomplete-wrapper .plp-card'
                        ))
                ) {
                    shouldSync = true;
                    break;
                }
            }
        }
        if (!shouldSync) return;

        window.clearTimeout(wizzyMetaRestoreTimer);
        wizzyMetaRestoreTimer = window.setTimeout(function () {
            wizzyMetaRestoreTimer = null;
            // Restore only - do not re-schedule fetch here (avoids attribute write loops).
            restoreWizzyMetaFromCache();
        }, 120);
    });
    wizzyMetaRestoreObserver.observe(root, {
        subtree: true,
        attributes: true,
        attributeFilter: ['data-min-weight-state', 'data-weight-hydrated', 'data-product-id'],
    });
}

function ensureWizzyMetaPageshowBinding() {
    if (wizzyMetaPageshowBound) return;
    wizzyMetaPageshowBound = true;
    window.addEventListener('pageshow', function () {
        scheduleHydrateWizzyCardMeta(50);
    });
    document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
            scheduleHydrateWizzyCardMeta(80);
        }
    });
}

/**
 * POST {base}/public/products/weights/products-batch
 * Returns weight (overallMinWeight) + qty (totalAvailableQuantity) per productId.
 */
function fetchWizzyProductsBatchMeta(productIds, cfg) {
    var base = String(cfg.apiBaseUrl || '').replace(/\/+$/, '');
    var url = base + '/public/products/weights/products-batch';
    var headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };
    try {
        if (new URL(url, window.location.origin).hostname.toLowerCase().indexOf('ngrok') >= 0) {
            headers['ngrok-skip-browser-warning'] = 'true';
        }
    } catch (e) {
        /* noop */
    }

    var requestKey = productIds
        .map(normalizeWizzyProductId)
        .filter(Boolean)
        .sort()
        .join(',');

    if (wizzyMetaInFlightPromise && wizzyMetaInFlightKey === requestKey) {
        return wizzyMetaInFlightPromise;
    }

    var timeoutMs = Math.max(
        WIZZY_WMS_REQUEST_TIMEOUT_MS,
        Number(cfg.timeoutMs) || WIZZY_WMS_REQUEST_TIMEOUT_MS
    );

    function once() {
        var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        var timeoutId = window.setTimeout(function () {
            if (controller) controller.abort();
        }, timeoutMs);

        return fetch(url, {
            method: 'POST',
            mode: 'cors',
            credentials: 'omit',
            headers: headers,
            body: JSON.stringify({ productIds: productIds }),
            signal: controller ? controller.signal : undefined,
        })
            .then(function (res) {
                if (!res.ok) throw new Error('Products-batch API HTTP ' + res.status);
                return res.json();
            })
            .then(function (payload) {
                return parseWizzyProductsBatchMetaMap(payload, productIds);
            })
            .finally(function () {
                window.clearTimeout(timeoutId);
            });
    }

    wizzyMetaInFlightKey = requestKey;
    wizzyMetaInFlightPromise = once()
        .catch(function () {
            return once();
        })
        .finally(function () {
            if (wizzyMetaInFlightKey === requestKey) {
                wizzyMetaInFlightKey = '';
                wizzyMetaInFlightPromise = null;
            }
        });

    return wizzyMetaInFlightPromise;
}

/**
 * @param {unknown} payload
 * @param {string[]} requestedIds
 * @returns {Record<string, { weight: number|null, qty: number|null }>}
 */
function parseWizzyProductsBatchMetaMap(payload, requestedIds) {
    var result = {};
    var requested = {};
    (requestedIds || []).forEach(function (id) {
        var key = normalizeWizzyProductId(id);
        if (key) requested[key] = true;
    });

    function assign(productId, weight, qty) {
        var key = normalizeWizzyProductId(productId);
        if (!key) return;
        if (Object.keys(requested).length && !requested[key]) return;
        var qtyN = Number(qty);
        var safeQty = Number.isFinite(qtyN) && qtyN >= 0 ? Math.floor(qtyN) : 0;
        var weightN = Number(weight);
        result[key] = {
            // Qty drives availability; weight only meaningful when qty > 0.
            weight: safeQty > 0 && Number.isFinite(weightN) && weightN > 0 ? weightN : null,
            qty: safeQty,
        };
    }

    var products = null;
    if (payload && typeof payload === 'object') {
        if (payload.data && Array.isArray(payload.data.products)) {
            products = payload.data.products;
        } else if (Array.isArray(payload.products)) {
            products = payload.products;
        } else if (Array.isArray(payload.data)) {
            products = payload.data;
        } else if (Array.isArray(payload)) {
            products = payload;
        }
    }

    if (!products) {
        Object.keys(requested).forEach(function (key) {
            result[key] = { weight: null, qty: 0 };
        });
        return result;
    }

    products.forEach(function (product) {
        if (!product || typeof product !== 'object') return;
        var normalized = normalizeWizzyMetaFromProduct(product);
        var productId = product.productId != null ? product.productId : product.id;
        assign(productId, normalized.weight, normalized.qty);
    });

    // Every requested product must resolve — never leave loading.
    Object.keys(requested).forEach(function (key) {
        if (!Object.prototype.hasOwnProperty.call(result, key)) {
            result[key] = { weight: null, qty: 0 };
        }
    });

    return result;
}

/**
 * Unified Wizzy card meta hydrate (min weight + available qty + ATC):
 * Same business rules as collection weight-service.
 * Prefers AOneProductWeightsAPI when present to avoid a duplicate products-batch call.
 */
function hydrateWizzyCardMeta() {
    ensureWizzyMetaRestoreObserver();
    ensureWizzyMetaPageshowBinding();

    var cards = Array.prototype.slice.call(document.querySelectorAll(WIZZY_META_CARD_SELECTOR));
    if (!cards.length) return;

    var cfg = getWizzyWeightApiConfig();
    var productIds = [];
    var cardsById = {};
    var generation = ++wizzyMetaRequestGeneration;

    cards.forEach(function (card) {
        var productId = normalizeWizzyProductId(card.getAttribute('data-product-id'));
        if (!productId) {
            applyWizzyCardMeta(card, { weight: null, qty: 0 });
            return;
        }

        var cached = lookupWizzyCachedMeta(productId);
        if (cached !== undefined) {
            applyWizzyCardMeta(card, cached);
            return;
        }

        var fromStore = lookupWizzyMetaFromAOneStore(productId);
        if (fromStore !== undefined) {
            storeWizzyCachedMeta(productId, fromStore);
            applyWizzyCardMeta(card, fromStore);
            return;
        }

        setWizzyCardMetaLoading(card);

        if (!cfg || !cfg.apiBaseUrl) {
            applyWizzyCardMeta(card, { weight: null, qty: 0 });
            return;
        }

        if (productIds.indexOf(productId) === -1) productIds.push(productId);
        if (!cardsById[productId]) cardsById[productId] = [];
        cardsById[productId].push(card);
    });

    if (!productIds.length) return;
    if (!cfg || !cfg.apiBaseUrl) return;

    function applyResolvedMetaMap(map) {
        if (generation !== wizzyMetaRequestGeneration) return;
        productIds.forEach(function (productId) {
            var meta = Object.prototype.hasOwnProperty.call(map, productId)
                ? map[productId]
                : { weight: null, qty: 0 };
            storeWizzyCachedMeta(productId, meta);
            (cardsById[productId] || []).forEach(function (card) {
                applyWizzyCardMeta(card, meta);
            });
        });
        window.setTimeout(restoreWizzyMetaFromCache, 100);
        window.setTimeout(restoreWizzyMetaFromCache, 600);
        window.setTimeout(restoreWizzyMetaFromCache, 1600);
    }

    function applyComingSoonFallback(reason) {
        if (generation !== wizzyMetaRequestGeneration) return;
        if (reason) console.error('[WMS availability]', reason);
        var fallbackMap = {};
        productIds.forEach(function (productId) {
            var fromStore = lookupWizzyMetaFromAOneStore(productId);
            fallbackMap[productId] =
                fromStore !== undefined ? fromStore : { weight: null, qty: 0 };
        });
        applyResolvedMetaMap(fallbackMap);
    }

    // Prefer theme weight-service so Wizzy SLP/CLP share one products-batch + store.
    var weightApi = window.AOneProductWeightsAPI || window.AoneBatchWeight;
    if (weightApi && typeof weightApi.loadCurrentProductWeights === 'function') {
        Promise.resolve(weightApi.loadCurrentProductWeights(productIds))
            .then(function () {
                if (generation !== wizzyMetaRequestGeneration) return;
                var map = {};
                productIds.forEach(function (productId) {
                    var fromStore = lookupWizzyMetaFromAOneStore(productId);
                    map[productId] =
                        fromStore !== undefined ? fromStore : { weight: null, qty: 0 };
                });
                applyResolvedMetaMap(map);
            })
            .catch(function (error) {
                console.error('[WMS availability] Wizzy weight-service request failed', error);
                // Fall back to Wizzy-owned batch fetch once.
                fetchWizzyProductsBatchMeta(productIds, cfg)
                    .then(function (map) {
                        applyResolvedMetaMap(map);
                    })
                    .catch(function (fetchError) {
                        applyComingSoonFallback(fetchError);
                    });
            });
        return;
    }

    fetchWizzyProductsBatchMeta(productIds, cfg)
        .then(function (map) {
            applyResolvedMetaMap(map);
        })
        .catch(function (error) {
            applyComingSoonFallback(error);
        });
}

function hydrateWizzyCardAvailableQty() {
    hydrateWizzyCardMeta();
}

function applyWizzyLowStockBadges() {
    // Low Stock is intentionally removed. WMS inventory uses only AVAILABLE / COMING SOON.
    // Keep SKU/min-weight interim hydration without Shopify-based low-stock badges.
    var cards = document.querySelectorAll(
        '.wizzy-search-results-list .plp-card, .wizzy-autocomplete-wrapper .plp-card'
    );

    cards.forEach(function (card) {
        if (card.getAttribute('data-wizzy-low-stock-checked')) {
            return;
        }

        var link = card.querySelector('.plp-card__media-link');
        var variantInput = card.querySelector('input[name="id"]');
        if (!link || !variantInput) {
            return;
        }

        card.setAttribute('data-wizzy-low-stock-checked', 'true');

        var existingLow = card.querySelector('[data-wizzy-low-stock]');
        if (existingLow) existingLow.remove();

        getAvailableStockForVariants(link.href).then(function (stockMap) {
            var resolvedSku = stockMap && stockMap._sku ? String(stockMap._sku).trim() : '';
            if (resolvedSku) {
                setWizzyCardSku(card, resolvedSku);
            }
            card.__wizzyQtyMinWeight = stockMap && stockMap._min_weight_grams;

            if (
                card.getAttribute('data-wizzy-weight-ready') !== 'true' &&
                card.__wizzyQtyMinWeight != null &&
                Number(card.__wizzyQtyMinWeight) > 0
            ) {
                var existingSku = readWizzyCardSku(card);
                if (!existingSku || lookupWizzyCachedWeight(existingSku) === undefined) {
                    applyWizzyMinWeightDisplay(card, card.__wizzyQtyMinWeight, { interim: true });
                }
            }
        });
    });
}
    const targetNode = document.querySelector(".wizzy-body-end-wrapper");
    function updateBodyClass() {
        const autocompleteElement = targetNode.querySelector(".wizzy-autocomplete-wrapper");
        var isOpen =
            autocompleteElement &&
            window.getComputedStyle(autocompleteElement).display === "flex";
        if (isOpen) {
            document.body.classList.add("wizzy-autocomplete-open");
            setTimeout(syncAutocompleteWidth, 0);
            scheduleHydrateWizzyCardMeta(60);
        } else {
            document.body.classList.remove("wizzy-autocomplete-open");
        }
    }
    const config = {
        childList: !0,
        subtree: !0,
        attributes: !0,
        attributeFilter: ["style"]
    }
      , callback = function(mutationsList, observer2) {
        for (const mutation of mutationsList) {
            updateBodyClass();
            break
        }
    }
      , observer = new MutationObserver(callback);
    targetNode && (observer.observe(targetNode, config),
    updateBodyClass());

var WIZZY_SEARCH_VIEW_KEY = 'wizzy-search-plp-view';
var wizzyViewSwitcherTimer;
var WIZZY_SEARCH_VIEWS = { grid: true, inventory: true };

function getWizzySearchWrapper() {
    // Prefer the live results wrapper that currently has products / filters.
    var wrappers = document.querySelectorAll('.wizzy-search-wrapper');
    if (!wrappers.length) return null;
    for (var i = 0; i < wrappers.length; i++) {
        var candidate = wrappers[i];
        if (
            candidate.querySelector('.wizzy-search-results-list .plp-card, .wizzy-search-results-list .inventory-product-row, .search-filters-top-wrapper')
        ) {
            return candidate;
        }
    }
    return wrappers[0];
}

function getWizzySearchResultsLists() {
    var wrapper = getWizzySearchWrapper();
    if (!wrapper) return [];
    return Array.prototype.slice.call(wrapper.querySelectorAll('.wizzy-search-results-list'));
}

function getWizzyCartRoute(suffix) {
    var root = '/';
    try {
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
            root = window.Shopify.routes.root;
        }
    } catch (e) {
        /* noop */
    }
    if (root.slice(-1) !== '/') root += '/';
    return root + suffix;
}

/** Marks the Wizzy results area as a PLP view host so order-sheet + quick-view handlers work. */
function ensureWizzyPlpViewHost() {
    var wrapper = getWizzySearchWrapper();
    if (!wrapper) return null;

    var host =
        wrapper.querySelector('.plp-view-host[data-wizzy-plp-host]') ||
        wrapper.querySelector('.wizzy-search-results') ||
        wrapper;

    host.classList.add('plp-view-host');
    host.setAttribute('data-wizzy-plp-host', '');
    host.setAttribute('data-plp-enable-inventory', 'true');
    host.setAttribute('data-plp-enable-list', 'false');
    host.setAttribute('data-plp-enable-view4', 'false');
    host.setAttribute('data-plp-persist-views', 'true');
    if (!host.dataset.cartAddJs) {
        host.dataset.cartAddJs = getWizzyCartRoute('cart/add.js');
    }
    if (!host.dataset.cartJson) {
        host.dataset.cartJson = getWizzyCartRoute('cart.js');
    }
    return host;
}

function getWizzyViewSwitcherMarkup() {
    return (
        '<div class="plp-view-switcher plp-view-switcher--buttons plp-view-switcher--right" role="toolbar" aria-label="Product display layout">' +
        '<span class="plp-view-switcher__inner" role="presentation">' +
        '<button type="button" class="plp-view-switcher__btn" data-wizzy-view-switch="grid" aria-pressed="true" aria-label="Grid">' +
        '<span class="plp-view-switcher__text">Grid</span>' +
        '</button>' +
        '<button type="button" class="plp-view-switcher__btn" data-wizzy-view-switch="inventory" aria-pressed="false" aria-label="Order sheet">' +
        '<span class="plp-view-switcher__text">Order sheet</span>' +
        '</button>' +
        '</span>' +
        '</div>'
    );
}

function injectWizzyViewSwitcher() {
    var wrapper = getWizzySearchWrapper();
    if (!wrapper) {
        return;
    }

    ensureWizzyPlpViewHost();

    var topBar = wrapper.querySelector('.search-filters-top-wrapper');
    if (!topBar) {
        return;
    }

    var controls = wrapper.querySelector('[data-wizzy-view-controls]');
    if (!controls) {
        controls = document.createElement('div');
        controls.className = 'wizzy-search-view-switcher';
        controls.setAttribute('data-wizzy-view-controls', '');
        controls.innerHTML = getWizzyViewSwitcherMarkup();

        controls.addEventListener('click', function (event) {
            var btn = event.target instanceof Element ? event.target.closest('[data-wizzy-view-switch]') : null;
            if (!btn || !controls.contains(btn)) {
                return;
            }

            var view = btn.getAttribute('data-wizzy-view-switch');
            if (view && WIZZY_SEARCH_VIEWS[view]) {
                setWizzySearchView(view, true);
            }
        });

        var sortWrap = topBar.querySelector('.wizzy-search-sort-wrapper');
        if (sortWrap) {
            topBar.insertBefore(controls, sortWrap);
        } else {
            topBar.appendChild(controls);
        }
    } else if (
        controls.querySelector('[data-wizzy-view-switch="list"]') ||
        !controls.querySelector('[data-wizzy-view-switch="inventory"]')
    ) {
        controls.innerHTML = getWizzyViewSwitcherMarkup();
    }
}

function normalizeWizzySearchView(view) {
    if (view === 'list') return 'inventory';
    if (view === 'inventory') return 'inventory';
    return 'grid';
}

function setWizzySearchView(view, persist) {
    var wrapper = getWizzySearchWrapper();
    var resultsLists = getWizzySearchResultsLists();
    if (!wrapper || !resultsLists.length) {
        return;
    }

    var host = ensureWizzyPlpViewHost();
    var logical = normalizeWizzySearchView(view);
    var isInventory = logical === 'inventory';

    resultsLists.forEach(function (resultsList) {
        resultsList.classList.toggle('plp-product-grid--list-layout', false);
        resultsList.classList.toggle('plp-product-grid--inventory-layout', isInventory);
        resultsList.setAttribute('data-plp-layout', logical);
        resultsList.dataset.plpView = logical;
    });

    wrapper.classList.toggle('wizzy-search-wrapper--layout-list', false);
    wrapper.classList.toggle('wizzy-search-wrapper--layout-inventory', isInventory);

    if (host) {
        host.classList.toggle('plp-view-host--layout-list', false);
        host.classList.toggle('plp-view-host--layout-inventory', isInventory);
        host.dataset.plpDefaultView = logical;
    }

    var controls = wrapper.querySelector('[data-wizzy-view-controls]');
    if (controls) {
        controls.querySelectorAll('[data-wizzy-view-switch]').forEach(function (btn) {
            var active = btn.getAttribute('data-wizzy-view-switch') === logical;
            btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
    }

    if (persist) {
        try {
            localStorage.setItem(WIZZY_SEARCH_VIEW_KEY, logical);
        } catch (error) {
            /* noop */
        }
    }

    // Re-paint meta after layout switch (grid + order sheet share the same productIds).
    restoreWizzyMetaFromCache();
    scheduleHydrateWizzyCardMeta(80);
}

function initWizzySearchViewSwitcher() {
    injectWizzyViewSwitcher();
    syncWizzyProductHandlesInDom();

    var view = 'grid';
    try {
        var stored = localStorage.getItem(WIZZY_SEARCH_VIEW_KEY);
        if (stored) {
            view = normalizeWizzySearchView(stored);
        }
    } catch (error) {
        /* noop */
    }

    setWizzySearchView(view, false);
}

/** Fallback: open Quick View from Order sheet rows if PLP host binding is not ready yet. */
function bindWizzyOrderSheetQuickViewFallback() {
    if (document.documentElement.getAttribute('data-wizzy-os-qv-bound') === 'true') {
        return;
    }
    document.documentElement.setAttribute('data-wizzy-os-qv-bound', 'true');

    document.addEventListener(
        'click',
        function (event) {
            if (!(event.target instanceof Element)) return;
            var wrapper = getWizzySearchWrapper();
            if (!wrapper || !wrapper.classList.contains('wizzy-search-wrapper--layout-inventory')) return;
            if (!wrapper.contains(event.target)) return;
            if (event.target.closest('[data-order-sheet-details-panel], [data-plp-details-panel]')) return;

            var item = event.target.closest('[data-order-sheet-item], [data-plp-inventory-item]');
            if (!item || !wrapper.contains(item)) return;

            var row = event.target.closest('[data-order-sheet-row]') || item.querySelector('[data-order-sheet-row]');
            if (!row) return;

            var handle =
                row.getAttribute('data-product-handle') ||
                item.getAttribute('data-product-handle') ||
                '';
            if (!handle) {
                var gridItem = item.closest('.plp-product-grid__item, .wizzy-result-product');
                var link = (gridItem || item).querySelector('a[href*="/products/"]');
                var href = link instanceof HTMLAnchorElement ? link.getAttribute('href') || '' : '';
                var match = href.match(/\/products\/([^/?#]+)/);
                if (match && match[1]) {
                    handle = decodeURIComponent(match[1]);
                    row.setAttribute('data-product-handle', handle);
                    item.setAttribute('data-product-handle', handle);
                }
            }
            if (!handle) return;

            var qv = window.__aoneQuickViewModalController;
            if (!qv || typeof qv.open !== 'function') return;

            /* Let plp-table-details handle the click when a real PLP host wraps the item. */
            if (item.closest('.plp-view-host[data-plp-enable-inventory="true"]')) return;

            event.preventDefault();
            event.stopPropagation();
            qv.open(handle);
        },
        true
    );
}

bindWizzyOrderSheetQuickViewFallback();

new MutationObserver(function () {
    clearTimeout(wizzyViewSwitcherTimer);
    wizzyViewSwitcherTimer = setTimeout(initWizzySearchViewSwitcher, 150);
}).observe(document.body, { childList: true, subtree: true });

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWizzySearchViewSwitcher, { once: true });
} else {
    initWizzySearchViewSwitcher();
}

ensureWizzyMetaPageshowBinding();
scheduleHydrateWizzyCardMeta(300);

